import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import WorksServicePaymentRateNormsDt from '@/services/dataTransferModules/worksServicePaymentRateNormsDt'

const worksServicePaymentRateNormsDt = new WorksServicePaymentRateNormsDt()

export default function useWorksServicePaymentRateNorms() {
	const { t: $t } = useI18n()

	const {
		loadEntityFlags: flags,

		entities: fullWorksServicePaymentRateNorms,
		getEntities: getFulledWorksServicePaymentRateNorm,

		basedEntities: baseWorksServicePaymentRateNorms,
		getBasedEntities: getBasedWorksServicePaymentRateNorm,

		extendedEntities: extendedWorksServicePaymentRateNorms,
		getExtendedEntities: getExtendedWorksServicePaymentRateNorm,

		entity: worksServicePaymentRateNorm,
		getEntity: getWorksServicePaymentRateNorm,

		createEntity: createWorksServicePaymentRateNorm,
		patchEntity: updateWorksServicePaymentRateNorm,
		updateEntity: fullUpdateWorksServicePaymentRateNorm,
		deleteEntity: deleteWorksServicePaymentRateNorm,
	} = useBlProviders(worksServicePaymentRateNormsDt, {
		showErrorNotificationForLoadingAllEntities: true,
		errorNotificationTextForLoadingAllEntities: $t('Error while loading service charges rates'),

		showErrorNotificationForLoadingOneEntity: true,

		showErrorNotificationForCreatingEntity: true,

		showErrorNotificationForUpdatingEntity: true,

		showErrorNotificationForDeletingEntity: true,
	})

	const defaults = {
		creatingWorksServicePaymentRateNorm: {
			id: 0,
			name: '',
			metric: '',
			optimal_value: '',
			min_value: '',
			max_value: '',
			koef: '',
			work: null,
		},
		fieldsToPatch: [
			'name',
			'metric',
			'optimal_value',
			'min_value',
			'max_value',
			'koef',
			'work',
		],
	}

	return {
		flags,
		fullWorksServicePaymentRateNorms,
		baseWorksServicePaymentRateNorms,
		extendedWorksServicePaymentRateNorms,
		worksServicePaymentRateNorm,
		defaults,
		getBasedWorksServicePaymentRateNorm,
		getExtendedWorksServicePaymentRateNorm,
		getFulledWorksServicePaymentRateNorm,
		getWorksServicePaymentRateNorm,
		createWorksServicePaymentRateNorm,
		deleteWorksServicePaymentRateNorm,
		updateWorksServicePaymentRateNorm,
		fullUpdateWorksServicePaymentRateNorm,
	}
}
